export default class SmartPolicy {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        Object.defineProperty(this, "additionalPolicyText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancellationSummaryRows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancellationText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancellationType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancellationTypeText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fullyRefundableUntilDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // ISO 8601 format "YYYY-MM-DD"
        Object.defineProperty(this, "fullyRefundableUntilDaysBeforeCheckIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "guaranteeText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noShowText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "paymentSummaryRows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.additionalPolicyText = data.additionalPolicyText;
        this.cancellationSummaryRows = (_a = data.cancellationSummaryRows) !== null && _a !== void 0 ? _a : [];
        this.cancellationText = data.cancellationText;
        this.cancellationType = ((_b = data.cancellationType) === null || _b === void 0 ? void 0 : _b.type) || null;
        this.cancellationTypeText = ((_c = data.cancellationType) === null || _c === void 0 ? void 0 : _c.text) || null;
        this.fullyRefundableUntilDate =
            ((_d = data.cancellationType) === null || _d === void 0 ? void 0 : _d.fullyRefundableUntilDaysBeforeDate) || null;
        this.fullyRefundableUntilDaysBeforeCheckIn =
            (_f = (_e = data.cancellationType) === null || _e === void 0 ? void 0 : _e.fullyRefundableUntilDaysBeforeCheckIn) !== null && _f !== void 0 ? _f : null;
        this.guaranteeText = data.guaranteeText;
        this.id = data.id;
        this.name = data.name;
        this.noShowText = (_g = data.noShowText) !== null && _g !== void 0 ? _g : '';
        this.paymentSummaryRows = (_h = data.paymentSummaryRows) !== null && _h !== void 0 ? _h : [];
        this.rootId = data.rootId;
    }
}
